module.exports = __webpack_public_path__ + "img/Frente-24-01 on.fa0f6440.png";